import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio } from "vue";
const _hoisted_1 = { class: "space-y-8 divide-y divide-gray-200 sm:space-y-5" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Approve ATR\n          "),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("p", { class: "mt-1 max-w-2xl text-sm text-gray-500" }, "\n            This information will be displayed publicly so be careful what you\n            share.\n          ")
], -1);
const _hoisted_3 = { class: "mt-6 sm:mt-5 space-y-6 sm:space-y-5" };
const _hoisted_4 = {
    key: 0,
    class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
};
const _hoisted_5 = {
    key: 0,
    for: "approval",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
};
const _hoisted_6 = {
    key: 1,
    class: "mt-1 sm:mt-0 sm:col-span-2"
};
const _hoisted_7 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_8 = {
    key: 2,
    class: "mt-1 sm:mt-0 sm:col-span-2"
};
const _hoisted_9 = { class: "max-w-lg flex rounded-md" };
const _hoisted_10 = { class: "pt-6 sm:pt-5" };
const _hoisted_11 = {
    role: "group",
    "aria-labelledby": "label-notifications"
};
const _hoisted_12 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-baseline" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("div", {
        id: "approve-atr",
        class: "text-base font-medium text-gray-900 sm:text-sm sm:text-gray-700"
    }, "\n                    Are you happy to approve this ATR? *\n                  ")
], -1);
const _hoisted_14 = { class: "sm:col-span-2" };
const _hoisted_15 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_16 = { class: "max-w-lg" };
const _hoisted_17 = { class: "mt-4 space-y-4" };
const _hoisted_18 = { class: "flex items-center" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("label", {
    for: "approve-atr",
    class: "ml-3 block text-sm font-medium text-gray-700"
}, "Yes", -1);
const _hoisted_20 = { class: "flex items-center" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("label", {
    for: "approve-atr",
    class: "ml-3 block text-sm font-medium text-gray-700"
}, "No", -1);
const _hoisted_22 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("label", {
    for: "approval",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}, "Approval Date: *", -1);
const _hoisted_24 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_25 = { class: "max-w-lg flex rounded-md shadow-sm" };
const _hoisted_26 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_27 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("label", {
    for: "comments",
    class: "block text-sm font-medium text-gray-700"
}, "Approval Comments", -1);
const _hoisted_29 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_30 = {
    key: 1,
    class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
};
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("label", {
    for: "secondLineApprover",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}, "\n                Who will be providing second line approval for this ATR? *\n              ", -1);
const _hoisted_32 = {
    key: 2,
    class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
};
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("label", {
    for: "approval",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}, "\n              Who will be providing second line approval for this ATR? *\n              ", -1);
const _hoisted_34 = {
    key: 0,
    class: "mt-1 sm:mt-0 sm:col-span-2"
};
const _hoisted_35 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_36 = {
    key: 1,
    class: "mt-1 sm:mt-0 sm:col-span-2"
};
const _hoisted_37 = { class: "max-w-lg flex rounded-md" };
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("p", { class: "mt-2 text-sm text-blue-500" }, "\n                * The second line approver is the HR professional who will ensure all the correct policies and approvals have\n                been adhered to. If further approvals are required, they will co-ordinate this with the business outside the\n                system and keep records locally for audit purposes. You can either type their name (surname than space first name)\n                eg Bloggs Joe and select person icon or you can open the address book and search for their name (this is linked to the email directory)\n              ", -1);
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("p", { class: "mt-2 text-sm text-blue-500" }, "\n                * Once all mandatory fields (*) have been completed, you will be able to see an Approve this ATR button to allow\n                you to submit the ATR to the next stage in the process. If you cannot see a Approve this ATR button, the you will need to review\n                need to review the form and complete any missing information.\n              ", -1);
const _hoisted_40 = {
    key: 0,
    class: "pt-5"
};
const _hoisted_41 = { class: "flex justify-end" };
const _hoisted_42 = ["disabled"];
import { XIcon } from '@heroicons/vue/solid';
import useVuelidate from '@vuelidate/core';
import { helpers, required, requiredIf } from '@vuelidate/validators';
import { Auth } from 'aws-amplify';
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import UserSearch from '@/components/userDropdownSearch.vue';
import httpClient from '@/httpClient';
import { getStorage, saveStorage } from '@/storageSave';
export default /*#__PURE__*/ _defineComponent({
    __name: 'approval-form',
    props: {
        sla: { default: null }
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        const editedSecondLine = ref(false);
        const first_line = ref('');
        const first_line_show = ref(false);
        const second_line = ref('');
        const happy_to_approve = ref('');
        const approval_date = ref('');
        const approvalComment = ref('');
        const hr_prof_show = ref(false);
        const atrData = computed(() => {
            return JSON.parse(getStorage('formData'));
        });
        const currentStage = computed(() => {
            return atrData.value.currentStageName;
        });
        const userprofile = computed(() => {
            return Auth?.user.signInUserSession.idToken.payload ?? '';
        });
        const hasSecondLineApprover = () => {
            if (props.sla) {
                return true;
            }
            return false;
        };
        const handleUser = (event) => {
            first_line.value = event.email.trim();
            first_line_show.value = true;
        };
        const handleClearFirstLine = (event) => {
            const target = event.explicitOriginalTarget;
            if (target?.id !== 'userSearch') {
                first_line.value = '';
                first_line_show.value = false;
            }
        };
        const handleSecond = (event) => {
            second_line.value = event.email.trim();
            hr_prof_show.value = true;
        };
        const handleClearSecondLine = () => {
            second_line.value = '';
            hr_prof_show.value = false;
        };
        const sendApprove = async (event) => {
            event.preventDefault();
            let firstLine;
            if (atrData.value['starter.notifyBudgetApproverApproval']?.approverEmail) {
                firstLine =
                    atrData.value['starter.notifyBudgetApproverApproval']?.approverEmail;
            }
            else {
                firstLine = first_line.value;
            }
            const formData = {
                first_line: firstLine,
                happy_to_approve: happy_to_approve.value,
                approval_date: approval_date.value,
                approvalComment: approvalComment.value,
                secondLineApproval: second_line.value,
                approved: 'TRUE',
                stage: atrData.value.currentStageName,
                id: atrData.value.docId,
                requestedBy: userprofile.value.email,
                docOwner: atrData.value.requestedBy,
            };
            if (formData.stage === 'SUBMITTED' &&
                atrData.value.GSI11SK.includes('STARTER.NOTIFYHROPS')) {
                formData.stage = 'starter.notifyHROps';
            }
            else if (formData.stage === 'SUBMITTED' &&
                atrData.value.GSI11SK.includes('STARTER.NOTIFYBUDGETAPPROVER')) {
                formData.stage = 'starter.notifyBudgetApprover';
            }
            const response = await httpClient.post('/bff/action-request', formData);
            // update formData with the response
            saveStorage('formData', response.data.body.Attributes);
            router.push('/');
        };
        const handleCancel = () => {
            router.go(-1);
        };
        const rules = computed(() => ({
            first_line: {
                requiredIf: helpers.withMessage('This field is required', requiredIf(currentStage.value === 'starter.notifyBudgetApprover' ||
                    atrData.value.GSI11SK.includes('STARTER.NOTIFYBUDGETAPPROVER'))),
            },
            approval_date: { required },
            happy_to_approve: { required },
            second_line: {
                requiredIf: helpers.withMessage('This field is required', requiredIf(currentStage.value === 'starter.notifyBudgetApprover' ||
                    atrData.value.GSI11SK.includes('STARTER.NOTIFYBUDGETAPPROVER'))),
            },
        }));
        const v$ = useVuelidate(rules, {
            first_line,
            approval_date,
            happy_to_approve,
            second_line,
        });
        onMounted(() => {
            const date = new Date();
            approval_date.value =
                date.getFullYear().toString().padStart(4, '0') +
                    '-' +
                    (date.getMonth() + 1).toString().padStart(2, '0') +
                    '-' +
                    date.getDate().toString().padStart(2, '0');
            if (currentStage.value === 'starter.notifyHROps' ||
                atrData.value.GSI11SK.includes('STARTER.NOTIFYHROPS')) {
                // Comparison removed - was unused expression
            }
            if (hasSecondLineApprover()) {
                second_line.value = props.sla || '';
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", {
                class: "space-y-8 divide-y divide-gray-200 px-4 py-3",
                novalidate: "",
                onSubmit: sendApprove
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", null, [
                        _hoisted_2,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_3, [
                            (currentStage.value === 'starter.notifyBudgetApprover' || atrData.value.GSI11SK.includes('STARTER.NOTIFYBUDGETAPPROVER'))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    (atrData.value.currentStageName === 'starter.notifyBudgetApprover' || atrData.value.GSI11SK.includes('STARTER.NOTIFYBUDGETAPPROVER'))
                                        ? (_openBlock(), _createElementBlock("label", _hoisted_5, "Who will be providing first line approval for this ATR? *"))
                                        : _createCommentVNode("", true),
                                    _createTextVNode(),
                                    (!first_line_show.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            _createVNode(UserSearch, {
                                                group: "HM",
                                                onUpdatedUser: _cache[0] || (_cache[0] = ($event) => (handleUser($event))),
                                                onBlur: _cache[1] || (_cache[1] = ($event) => (_unref(v$).first_line.$touch()))
                                            }),
                                            _createTextVNode(),
                                            (_unref(v$).first_line.$errors.length)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "\n                * " + _toDisplayString(_unref(v$).first_line.$errors[0].$message), 1))
                                                : _createCommentVNode("", true)
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                            _createElementVNode("div", _hoisted_9, [
                                                _withDirectives(_createElementVNode("input", {
                                                    id: "approval",
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((first_line).value = $event)),
                                                    type: "email",
                                                    name: "approval",
                                                    disabled: "",
                                                    class: "flex-1 block w-full focus:ring-indigo-500 focus:border-indigo-500 min-w-0 rounded-none rounded-r-md sm:text-sm border-gray-300 disabled:cursor-not-allowed disabled:bg-gray-200"
                                                }, null, 512), [
                                                    [_vModelText, first_line.value]
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("button", {
                                                    class: "text-gray-400 hover:text-gray-800 ml-2",
                                                    onClick: _withModifiers(handleClearFirstLine, ["prevent"])
                                                }, [
                                                    _createVNode(_unref(XIcon), { class: "h-5 w-5" })
                                                ])
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("p", {
                                                class: _normalizeClass(["mt-1 text-sm text-gray-500", { 'displayNone': atrData.value.currentStageName !== 'starter.notifyBudgetApprover' && !atrData.value.GSI11SK.includes('STARTER.NOTIFYBUDGETAPPROVER') }])
                                            }, "\n                The first line approver is the business representative who has\n                the authority to approve the budget spend for this role.\n              ", 2),
                                            _createTextVNode(),
                                            _createElementVNode("p", {
                                                class: _normalizeClass(["mt-1 text-sm text-gray-500", { 'displayNone': atrData.value.currentStageName !== 'starter.notifyHROps' && !atrData.value.GSI11SK.includes('STARTER.NOTIFYHROPS') }])
                                            }, "\n                The second line approver is the HROps representative who has\n                the authority to approve the budget spend for this role.\n              ", 2)
                                        ]))
                                ]))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                        _hoisted_13,
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_14, [
                                            (_unref(v$).happy_to_approve.$errors.length)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, "\n                    * " + _toDisplayString(_unref(v$).happy_to_approve.$errors[0].$message), 1))
                                                : _createCommentVNode("", true),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_16, [
                                                _createElementVNode("div", _hoisted_17, [
                                                    _createElementVNode("div", _hoisted_18, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            id: "approve-atr",
                                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((happy_to_approve).value = $event)),
                                                            name: "approve-atr",
                                                            type: "radio",
                                                            value: "yes",
                                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300",
                                                            onBlur: _cache[4] || (_cache[4] = ($event) => (_unref(v$).happy_to_approve.$touch()))
                                                        }, null, 544), [
                                                            [_vModelRadio, happy_to_approve.value]
                                                        ]),
                                                        _createTextVNode(),
                                                        _hoisted_19
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("div", _hoisted_20, [
                                                        _createElementVNode("input", {
                                                            id: "approve-atr",
                                                            name: "approve-atr",
                                                            type: "radio",
                                                            value: "no",
                                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300",
                                                            onBlur: _cache[5] || (_cache[5] = ($event) => (_unref(v$).happy_to_approve.$touch()))
                                                        }, null, 32),
                                                        _createTextVNode(),
                                                        _hoisted_21
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_22, [
                                _hoisted_23,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("div", _hoisted_25, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: "approval",
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((approval_date).value = $event)),
                                            readonly: "",
                                            type: "date",
                                            name: "approval",
                                            autocomplete: "username",
                                            class: "flex-1 block w-full focus:ring-indigo-500 focus:border-indigo-500 min-w-0 rounded-none rounded-r-md sm:text-sm border-gray-300",
                                            onBlur: _cache[7] || (_cache[7] = ($event) => (_unref(v$).approval_date.$touch()))
                                        }, null, 544), [
                                            [_vModelText, approval_date.value]
                                        ]),
                                        _createTextVNode(),
                                        (_unref(v$).approval_date.$errors.length)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, "\n                  * " + _toDisplayString(_unref(v$).approval_date.$errors[0].$message), 1))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_27, [
                                _hoisted_28,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_29, [
                                    _withDirectives(_createElementVNode("textarea", {
                                        id: "about",
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((approvalComment).value = $event)),
                                        name: "about",
                                        rows: "3",
                                        class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md"
                                    }, null, 512), [
                                        [_vModelText, approvalComment.value]
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            (!editedSecondLine.value && hasSecondLineApprover() && (currentStage.value === 'starter.notifyHROps' || atrData.value.GSI11SK.includes('STARTER.NOTIFYHROPS')))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    _hoisted_31,
                                    _createTextVNode(),
                                    _createVNode(UserSearch, {
                                        group: "HROPS",
                                        "read-only": hasSecondLineApprover,
                                        "selected-email": _ctx.sla,
                                        "onUpdate:selectedEmail": _cache[9] || (_cache[9] = ($event) => (editedSecondLine.value = true))
                                    }, null, 8, ["selected-email"])
                                ]))
                                : ((!hasSecondLineApprover() || editedSecondLine.value) && (currentStage.value === 'starter.notifyBudgetApprover' || currentStage.value === 'starter.notifyHROps' || atrData.value.GSI11SK.includes('STARTER.NOTIFYBUDGETAPPROVER') || atrData.value.GSI11SK.includes('STARTER.NOTIFYHROPS')))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                        _hoisted_33,
                                        _createTextVNode(),
                                        (!hr_prof_show.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                                _createVNode(UserSearch, {
                                                    group: "HROPS",
                                                    onUpdatedUser: _cache[10] || (_cache[10] = ($event) => (handleSecond($event))),
                                                    onBlur: _cache[11] || (_cache[11] = ($event) => (_unref(v$).second_line.$touch()))
                                                }),
                                                _createTextVNode(),
                                                (_unref(v$).second_line.$errors.length)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, "\n                  * " + _toDisplayString(_unref(v$).second_line.$errors[0].$message), 1))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                                _createElementVNode("div", _hoisted_37, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        id: "hr-managers",
                                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((second_line).value = $event)),
                                                        type: "email",
                                                        name: "hr-managers",
                                                        autocomplete: "hr-managers",
                                                        disabled: "",
                                                        class: "flex-1 block w-full focus:ring-indigo-500 focus:border-indigo-500 min-w-0 rounded-none rounded-r-md sm:text-sm border-gray-300 disabled:cursor-not-allowed disabled:bg-gray-200"
                                                    }, null, 512), [
                                                        [_vModelText, second_line.value]
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("button", {
                                                        class: "text-gray-400 hover:text-gray-800 ml-2",
                                                        onClick: _withModifiers(handleClearSecondLine, ["prevent"])
                                                    }, [
                                                        _createVNode(_unref(XIcon), { class: "h-5 w-5" })
                                                    ])
                                                ]),
                                                _createTextVNode(),
                                                _hoisted_38,
                                                _createTextVNode(),
                                                _hoisted_39
                                            ]))
                                    ]))
                                    : _createCommentVNode("", true)
                        ])
                    ])
                ]),
                _createTextVNode(),
                (currentStage.value === 'starter.notifyBudgetApprover' || currentStage.value === 'starter.notifyHROps' || atrData.value.GSI11SK.includes('STARTER.NOTIFYBUDGETAPPROVER') || atrData.value.GSI11SK.includes('STARTER.NOTIFYHROPS'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                                onClick: handleCancel
                            }, "\n          Cancel\n        "),
                            _createTextVNode(),
                            _createElementVNode("button", {
                                disabled: _unref(v$).$invalid,
                                type: "submit",
                                class: "ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-500 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-200 disabled:text-gray-400 disabled:cursor-not-allowed"
                            }, "\n          Save\n        ", 8, _hoisted_42)
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ], 32));
        };
    }
});
